<mbs-modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="title">
  <ng-container modal-body>
    @if (ready()) {
      @if (isUnix()) {
        <mbs-schedule-step [(ngModel)]="value"></mbs-schedule-step>
      } @else {
        <mbs-nbf-schedule-step
          [showOverdue]="false"
          [showSyntheticFull]="false"
          [title]="title"
          [(ngModel)]="value"></mbs-nbf-schedule-step>
      }
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
